export default function getFingerPrint() {
  return import(/* webpackChunkName: "static/chunk/common/libraries/nanoid" */ 'nanoid').then(
    nanoid => nanoid
  );
}
